import type * as createNewFolder from './createNewFolder';
import { LazyModule, LazyAction } from 'owa-bundling';

export const lazyCreateNewFolder: LazyAction<
    typeof createNewFolder.createNewFolder,
    LazyModule<typeof createNewFolder>
> = new LazyAction(
    new LazyModule<typeof createNewFolder>(
        () => import(/* webpackChunkName: "CreateNewFolder" */ './createNewFolder'),
        {
            name: 'CreateNewFolder',
        }
    ),
    m => m.createNewFolder
);
